// @ts-nocheck
import { MEMBERSHIPS } from './constants';

export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_ID;
export const GA_TRACKING_ID_2 = process.env.NEXT_PUBLIC_GA_ID_2;
export const GTM_TRACKING_ID = process.env.NEXT_PUBLIC_GTM_ID || '';

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  window.gtag?.('config', GA_TRACKING_ID, {
    page_path: url
  });
  window.gtag?.('config', GA_TRACKING_ID_2, {
    page_path: url
  });
};

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({ action, category, label, value }) => {
  window.gtag?.('event', action, {
    event_category: category,
    event_label: label,
    value: value
  });
};

type GtagEventType = 'conversion' | 'add_to_cart' | 'initiate_checkout';

type ConversionEventType = {
  planId?: string;
  transactionId?: string;
  eventType: GtagEventType;
};

// FFH-359: the thank-you Google Ads conversion, enhanced conversion and GA4
// purchase events that used to fire here directly now fire from the GTM
// container off the `purchase` dataLayer push, deduped with the server CAPI on
// a shared event_id. `gtagConversionEvent` is retained for the /join page
// `initiate_checkout` conversion, which has no GTM equivalent today.
export const gtagConversionEvent = ({
  planId,
  transactionId,
  eventType
}: ConversionEventType) => {
  const sendToID = MembershipConversionIdDict[planId];

  window.gtag?.('event', eventType, {
    ...(sendToID ? { send_to: sendToID } : {}),
    // Guard on the raw value: `String(undefined)` is the truthy string
    // "undefined", which would otherwise send transaction_id: "undefined"
    // for callers that omit it (e.g. /join initiate_checkout).
    ...(transactionId ? { transaction_id: String(transactionId) } : {})
  });
};

export const MembershipConversionIdDict = {
  [MEMBERSHIPS.PREMIUM_MONTHLY_ID]: 'AW-866940376/kVwUCPKlwdUBENjrsZ0D',
  [MEMBERSHIPS.PREMIUM_YEARLY_ID]: 'AW-866940376/lKMKCLK6sdUBENjrsZ0D',
  [MEMBERSHIPS.STANDARD_MONTHLY_ID]: 'AW-866940376/mOPOCOqZuMsDENjrsZ0D',
  [MEMBERSHIPS.STANDARD_YEARLY_ID]: 'AW-866940376/8ogrCIS5sdUBENjrsZ0D',
  [MEMBERSHIPS.ULTRA_YEARLY_ID]: 'AW-866940376/VCMHCJ-5sdUBENjrsZ0D',
  [MEMBERSHIPS.PRO_YEARLY_ID]: 'AW-866940376/977702047',
  [MEMBERSHIPS.PRO_MONTHLY_ID]: 'AW-866940376/977853822',
  [MEMBERSHIPS.STARTER_YEARLY_ID]: 'AW-866940376/977703589',
  [MEMBERSHIPS.STARTER_MONTHLY_ID]: 'AW-866940376/977855478'
};

export const EventCategoryDict = {
  [MEMBERSHIPS.PRO_YEARLY_ID]: 'pro',
  [MEMBERSHIPS.ULTRA_YEARLY_ID]: 'ultra',
  [MEMBERSHIPS.FREE_ID]: 'free',
  [MEMBERSHIPS.STARTER_YEARLY_ID]: 'starter'
};

export const MembershipLTVDict = {
  [MEMBERSHIPS.PRO_MONTHLY_ID]: 70,
  [MEMBERSHIPS.PRO_YEARLY_ID]: 180,
  [MEMBERSHIPS.ULTRA_YEARLY_ID]: 300,
  [MEMBERSHIPS.ULTRA_MONTHLY_ID]: 200,
  [MEMBERSHIPS.STARTER_MONTHLY_ID]: 40,
  [MEMBERSHIPS.STARTER_YEARLY_ID]: 90
};
